import { Picture } from 'ui/components/primitives';
import { mixins, styled, theme, utils } from 'ui/theme';

export const PriceSmall = {
  Component: styled.span`
    ${mixins.baseFont};
    display: grid;
    gap: ${theme.space[1]};
    color: ${theme.colors.build.darkLight};
    grid-column: 2 / auto;
    &[data-cursor='true'] {
      cursor: pointer;
    }

    ${utils.media.min('l')`
      grid-column: auto;
    `}
  `,

  Title: styled.small`
    font-size: ${theme.fontSizes.xs};
  `,

  Price: styled.span`
    font-size: ${theme.fontSizes.lg};
  `,
};

export const Info = {
  Component: styled.div`
    grid-column: 2 / span 2;
    &[data-cursor='true'] {
      cursor: pointer;
    }
    ${utils.media.min('l')`
    grid-column: auto;
  `}
  `,

  Code: styled.span`
    ${mixins.baseFont};
    background: ${theme.colors.build.lightDark1};
    border-radius: ${theme.radii.small};
    color: ${theme.colors.build.darkLight};
    font-size: ${theme.fontSizes.sm};
    grid-area: code;
    padding: ${theme.space[1]};
  `,

  Title: styled.span`
    ${mixins.baseFont};
    ${utils.lineClamp(2)}
    color: ${theme.colors.build.darkLight};
    font-size: ${theme.fontSizes.md};
    line-height: ${theme.sizes[6]};
    margin: ${theme.space[1]} 0;
    ${utils.media.min('s')`
  `}
  `,
};

export const ProductCompact = {
  Component: styled('div')`
    align-items: center;
    display: grid;
    gap: ${theme.space[4]};
    grid-template: auto auto / ${theme.sizes[10]} auto 1fr;
    justify-content: center;

    picture {
      align-self: start;
    }

    ${utils.media.min('l')`
      grid-template: auto / ${theme.sizes[10]} 200px auto auto;
    `}
  `,

  Info,

  Picture: styled(Picture)`
    img {
      background: ${theme.colors.build.lightLight};
      border-radius: ${theme.radii.small};
      padding: ${theme.space[1]};
    }
    &[data-cursor='true'] {
      cursor: pointer;
    }
  `,

  PriceSmall,
};

export const SkeletonProductCompact = {
  ButtonAdd: styled('div')`
    width: 100%;
    height: ${theme.sizes[12]};
  `,

  Component: styled(ProductCompact.Component)``,

  Picture: styled('div')`
    width: 100%;
    height: 100%;
  `,

  InfoComponent: styled(Info.Component)``,

  Code: styled('div')`
    width: calc(${theme.sizes[11]} * 2);
  `,

  Title: styled(Info.Title)``,

  PriceComponent: styled(PriceSmall.Component)`
    min-width: calc(${theme.sizes[6]} * 3);
  `,

  PriceTitle: styled(PriceSmall.Title)``,

  Price: styled(PriceSmall.Price)``,
};
